import React, { Component } from 'react'

import '../../../../assets/sass/pages/profile-settings.scss'

import ProfileSettingsCard from './ProfileSettingsCard'
import ProfileSettingsTabs from './ProfileSettingsTabs'

import { Row, Col } from 'react-bootstrap'

class ProfileSettings extends Component {
    render() {
        return (
            <div className="profile-settings">
                <Row className="gutters-12">
                    <Col lg={3}>
                        {this.renderLeftSide()}
                    </Col>
                    <Col lg={9}>
                        {this.renderSettingsTabs()}
                    </Col>
                </Row>
            </div>
        )
    }

    renderLeftSide() {
        return (
            <ProfileSettings.Card />
        )
    }

    renderSettingsTabs() {
        return (
            <ProfileSettings.Tabs />
        )
    }
}

ProfileSettings.Card = ProfileSettingsCard;
ProfileSettings.Tabs = ProfileSettingsTabs;

export default ProfileSettings